(() => {
  'use strict';
  const root = document.querySelector('[data-product-root]');
  const depth = document.querySelector('.kp-pdp-depth');
  if (!root || !depth || !window.KPCommerce) return;
  const product = JSON.parse(root.querySelector('[data-product-json]').textContent);
  const { units, unitMoney } = window.KPCommerce;
  const kind = depth.dataset.pdpKind;
  const comingSoon = root.dataset.comingSoon === 'true';
  const counterparts = JSON.parse(document.querySelector('[data-pdp-counterparts]')?.textContent || '[]');
  const write = (selector, text) => document.querySelectorAll(selector).forEach(node => { node.textContent = text; });
  const formatCount = value => new Intl.NumberFormat('en-US').format(value);
  const grams = value => value >= 1000 ? `${formatCount(value / 1000)}kg` : `${formatCount(value)}g`;
  function update(variant) {
    if (!variant) return;
    const unit = units(variant, product.handle);
    if (!unit) return;
    let amount = `${formatCount(unit.count)} ${unit.unit}${unit.count === 1 ? '' : 's'}`;
    let pack = '';
    let summary = '';
    if (kind === 'gummy') {
      amount = `${formatCount(unit.count)} gummies`;
      pack = 'Labeled gummy pouch';
      summary = `${amount} · ${depth.dataset.gummyFlavor} · 50mg ${depth.dataset.gummyActive} product line`;
    } else if (kind === 'capsule') {
      amount = `${grams(unit.count * .5)} of leaf fill`;
      pack = unit.count === 120 ? '1 × 120-count bottle' : `${formatCount(unit.count / 250)} × 250-count pouch${unit.count === 250 ? '' : 'es'}`;
      summary = `${formatCount(unit.count)} capsules · ${grams(unit.count * .5)} leaf fill · ${pack}`;
    } else if (kind === 'tablet') {
      amount = `${formatCount(unit.count)} tablets`;
      pack = 'Mango chewable tablets';
      summary = `${amount} · Mango · 150mg MIT product-line label`;
    } else {
      amount = grams(unit.count);
      pack = kind === 'powder' ? 'Resealable leaf pouch' : 'Labeled extract package';
      summary = `${amount} net weight · ${kind === 'powder' ? 'Finely milled kratom leaf' : 'Unflavored mitragynine extract powder'}`;
    }
    write('[data-pdp-selected-title]', variant.title);
    write('[data-pdp-content-amount]', amount);
    write('[data-pdp-package]', pack);
    write('[data-pdp-value]', `${unitMoney(variant.price / unit.count)} / ${unit.unit}`);
    write('[data-pdp-selection-summary]', summary);
    write('[data-pdp-stock]', comingSoon ? 'Coming soon' : variant.available ? 'Available to order' : 'Currently sold out');
    if (product.handle === 'bulk-kratom-capsules') {
      const handle = `${variant.options[0].toLowerCase().replace(/\s+/g, '-')}-kratom-capsules`;
      const counterpart = counterparts.find(item => item.handle === handle);
      const card = document.querySelector('[data-pdp-counterpart]');
      if (counterpart && card) {
        card.href = counterpart.url;
        const image = card.querySelector('img');
        image.src = counterpart.image;
        image.removeAttribute('srcset');
        image.alt = counterpart.title;
        image.dataset.kpImageHandle = counterpart.handle;
        write('[data-pdp-counterpart-title]', counterpart.title);
        write('[data-pdp-counterpart-price]', `From ${counterpart.price}`);
      }
    }
    const comparable = product.variants.filter(v => (comingSoon || v.available) && (!product.handle.startsWith('bulk-kratom-capsules') || v.options[0] === variant.options[0]));
    const smallest = comparable.reduce((a, v) => !a || units(v,product.handle)?.count < units(a,product.handle)?.count ? v : a, null);
    let valueNote = 'Calculated from your selected pack';
    if (smallest) {
      const baseline = smallest.price / units(smallest, product.handle).count;
      const saving = Math.floor((1 - variant.price / unit.count / baseline) * 100);
      if (saving > 0) valueNote = `${saving}% less per ${unit.unit} than the smallest ${comingSoon ? 'listed' : 'available'} pack`;
    }
    write('[data-pdp-value-note]', valueNote);
  }
  document.addEventListener('kp:variant-change', event => update(event.detail.variant));
  update(product.variants.find(v => String(v.id) === root.querySelector('[data-variant-id]').value));
  const header = document.querySelector('.kp-header');
  if (header) {
    const nav = document.querySelector('.kp-pdp-nav');
    const measure = () => {
      const headerHeight = Math.ceil(header.getBoundingClientRect().height);
      const navHeight = nav?.getBoundingClientRect().height || 0;
      const scrollPadding = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
      document.documentElement.style.setProperty('--kp-pdp-header', `${headerHeight}px`);
      document.documentElement.style.setProperty('--kp-pdp-anchor', `${Math.max(0, headerHeight + navHeight - scrollPadding + 12)}px`);
    };
    const observer = new ResizeObserver(measure);
    observer.observe(header);
    if (nav) observer.observe(nav);
    measure();
  }
})();
